/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getClockinEssentials} from '../api'

 export const useQueryGetClockinEssentials = createReactQueryHook('getClockinEssentials', getClockinEssentials)
